module.exports = __webpack_public_path__ + "img/label-1A4.46b43332.jpeg";